import { Box, Typography } from "@mui/material";

export const TitleSection = ({ title, value }: any) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          color: "var(--c-text-color)",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: 24,
              sm: 30,
              md: 34,
            },
            textTransform: 'capitalize'
          }}
        >
          {title}
        </Typography>
        {value && (
          <Box
            sx={{
              borderRadius: "5px",
              width: "100%",
              height: "5px",
              backgroundColor: "var(--c-second-color)",
            }}
          >
            <Box
              sx={{
                width: `${value}%`,
                borderRadius: "5px",
                backgroundColor: "var(--c-main-color)",
                height: "100%",
              }}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
